import { Guid } from '@web/utils';
import { ShippingMethodCode } from '../enums';

export class ShippingMethodDictionary {
  public constructor(
    private readonly data: {
      id: Guid;
      code: ShippingMethodCode;
      name: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }
}
